module.exports = __webpack_public_path__ + "static/media/notice_step2_img.4fe2803a.png";